// extracted by mini-css-extract-plugin
module.exports = {"root":"TabBar-root-l-J4k","default":"TabBar-default-3Bs4W","primary":"TabBar-primary-1ljWa","secondary":"TabBar-secondary-1vsb6"};